export const CONFIG = {
    API_BASE_URL:
        'https://host.geetek.ai',

    FIREBASE: {
        API_KEY: 'AIzaSyBngFdqVP0dRxc5cKJUFEBfrozE9tozVUM',
        AUTH_DOMAIN: 'sliver-2b5f1.firebaseapp.com',
        PROJECT_ID: 'sliver-2b5f1',
        STORAGE_BUCKET: 'sliver-2b5f1.firebasestorage.app',
        MESSAGING_SENDER_ID: '138322947299',
        APP_ID: '1:138322947299:web:5dc3aa50c850f44621a9d6',

        VAPID_KEY:
            'BEWaRv9CqwzEQFSsJl5RiECq0Rrrq48QlYunAwkzsqEDQEfvpsRXXDbIztZo99CKe4gO52tZg3Jj3DQPi-Fz1nk'
    },
    GOOGLE_CLIENT_ID: '1097491150013-7da1cbstss7j0p0dle2d3al1acmnf9pm.apps.googleusercontent.com'
};